import { styled } from 'styled-components';
import { SemanticTextColor } from '@foradevelopment/design-tokens';

import { createResponsiveSpacingStyle } from './createResponsiveSpacingStyle';
import { renderResponsiveIcon } from './renderResponsiveIcon';
import type { Colors, ResponsiveSpacing } from './types';

export type DefaultIconProps = {
  marginLeft?: ResponsiveSpacing;
  marginRight?: ResponsiveSpacing;
  marginTop?: ResponsiveSpacing;
  marginBottom?: ResponsiveSpacing;
  /** `containerSize` is basically to change the width & height of `<IconWrapper/>`, but this doesn't change the width/height of the SVG icon. */
  containerSize?: ResponsiveSpacing;
  /** `title` shows a text/description of the icon when you hover on the icon/illustration */
  title?: string;
  /** `width` sets the width for the SVG element (see css to understand) */
  width?: ResponsiveSpacing;
  /** To be used in scenarios where there might be a used of two different icon variants */
  variant?: string;
  /** The list of colors that the icon can be colored in  */
  color?: Colors | SemanticTextColor;
  /** To support styled components */
  className?: string;
};

const IconWrapper = styled.span<DefaultIconProps & any>`
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  ${props => props.containerSize && createResponsiveSpacingStyle('width', props.containerSize)};
  ${props => props.containerSize && createResponsiveSpacingStyle('height', props.containerSize)};
  ${props => props.marginLeft && createResponsiveSpacingStyle('margin-left', props.marginLeft)};
  ${props => props.marginRight && createResponsiveSpacingStyle('margin-right', props.marginRight)};
  ${props => props.marginTop && createResponsiveSpacingStyle('margin-top', props.marginTop)};
  ${props => props.marginBottom && createResponsiveSpacingStyle('margin-bottom', props.marginBottom)};

  // Sets SVG size
  & > svg,
  & > * > svg {
    ${props => props.iconWidth && createResponsiveSpacingStyle('width', props.iconWidth)};
  }
`;

type IconWrapperProps = DefaultIconProps & {
  /** Add or overide style */
  style?: object;
  children: React.ReactNode;
};

export const DefaultIconWrapper = ({
  marginLeft,
  marginRight,
  marginBottom,
  marginTop,
  containerSize,
  title,
  width,
  children,
  className,
  style,
}: IconWrapperProps) => {
  return (
    <IconWrapper
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginTop={marginTop}
      containerSize={containerSize}
      title={title}
      iconWidth={Array.isArray(width) ? renderResponsiveIcon(width) : width}
      style={style}
      className={className}
    >
      {children}
    </IconWrapper>
  );
};
